import React from 'react';
import { useMediaQuery } from 'react-responsive';
import styled from 'styled-components';

interface curriculum {
    header: string;
    content: string;
}

const CurriculumBox = (c: curriculum) => {
    const isSmallScreen = useMediaQuery({ query: '(max-width: 767px)' });
    return (
        <Box>
            {isSmallScreen?<></>:<h1>{c.header}</h1>}
            <div><h2>{c.content}</h2></div>
        </Box>
    );
};

export default CurriculumBox;

const Box = styled.div`
    width: 45.7rem;
    background: #2c3036;
    box-shadow: 0rem 0rem 2.3rem rgba(40, 39, 39, 0.25);
    backdrop-filter: blur(0.65rem);
    border-radius: 2.4rem;

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;

    margin: 0 1.5rem 3rem 1.5rem;

    padding: 3rem 4rem;
    box-sizing: border-box;

    cursor: pointer;

    @media (max-width: 767px) {
        margin: 0 auto;
        margin-top: 6.2rem;
        padding-top: 0.4rem;
        padding: 2rem;
        background-color: #354cda;
        width: 100%;
        height: 25rem;
    }
    transition: all 0.5s ease-in-out;
    :hover {
        background: #354cda;
        box-shadow: 0rem 0rem 2.3rem rgba(0, 0, 0, 0.25);
        backdrop-filter: blur(0.7rem);
    }

    h1 {
        font-family: 'Noto Sans KR';
        font-style: normal;
        font-weight: 900;
        font-size: 250%;
        line-height: 4.3rem;

        margin-bottom: 1.2rem;
    }

    h2 {
        font-family: 'Noto Sans KR';
        font-style: normal;
        font-weight: 400;
        font-size: 180%;
        line-height: 2.8rem;

        @media (max-width: 767px) {
            font-size: 2.5rem;
            line-height: 3.8rem;
            padding: 0;
            height: auto;
        }
    }
`;
